module.exports = __webpack_public_path__ + "img/gorra1.6190052d.png";